import { Component, Input } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-html',
  template: `
  <!-- class="card p-4" style="box-shadow: 6px 6px 4px lightgrey;" -->
    <div style="color:black; background-color: rgb(240, 248, 255); border-color: rgb(99, 23, 170);"
      class="card p-3 mt-4 mb-4" role="alert">
     <span [innerHtml]="value"></span>
    </div>
  `,
})
export class AppTextHtmlComponent extends FieldComponent {
  @Input() labelType: any;
}
